import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-21v1',
  templateUrl: './21v1.component.html',
})
export class VbGeneral21v1Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
